module.exports = __webpack_public_path__ + "media/images/brands/brand-mo-0f0ee8700f38e7d42ded101ca8fffa33.jpg";